import React, { useState, useEffect } from "react";

import "../css/PopupPin.css";

import InputData from "../../components/InputData";
import ButtonIconH from "../../components/ButtonIconH";
import Dropdown from "../../components/Dropdown";
import { post } from "../../js/post";
import { userData, selectedOptic } from "../../js/utils";

const AGENT_DROPDOWN_ID = "popup-pin-agent";
const PIN_INPUT_ID = "popup-pin-input";

export default ({ show, onAccept, onCancel }) => {
  const [pin, setPin] = useState("");
  const [agentList, setAgentList] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState(userData.id);
  const [validatingPin, setValidatingPin] = useState(false);

  async function getAgents() {
    const response = await post("support/Configuracion/ListarAgentes.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      basic: true,
    });
    setAgentList(
      (response || []).map((e) => ({
        id: e.id,
        text: `${e.nombre} ${e.apellidos}`.toUpperCase(),
      })),
    );
  }

  const onChangePin = (e) => {
    setPin(e);
  };

  const validatePin = async () => {
    if (pin.trim() === "") {
      return;
    }

    setValidatingPin(true);
    const response = await post("ValidarPin.php", {
      token: userData.token,
      idAgente: selectedAgentId,
      pin,
    });
    setValidatingPin(false);

    if (response && response.valido) {
      const agent = agentList.find((e) => e.id === selectedAgentId);
      onAccept({
        idAgente: selectedAgentId,
        nombreAgente: agent ? agent.text : "",
      });
    } else {
      setPin("");
      const el = document.querySelector("#" + PIN_INPUT_ID);
      if (el) {
        el.value = "";
        el.blur();
        el.focus();
      }
    }
  };

  const cancel = () => {
    onCancel();
  };

  useEffect(() => {
    if (show) {
      setPin("");
      setSelectedAgentId(userData.id);
      getAgents().then(() => {
        setTimeout(() => {
          const agentInput = document.querySelector(
            "#" + AGENT_DROPDOWN_ID + " input",
          );
          if (agentInput) {
            agentInput.focus();
            agentInput.select();
          }
        }, 0);
      });
    }
  }, [show]);

  return show ? (
    <div className="popup-container popup-normal popup-pin">
      <div className="popup-message">
        <div className="popup-header">
          <div className="popup-title">Control por PIN</div>
          <img
            src="/images/close-white.svg"
            loading="lazy"
            alt=""
            className="popup-close"
            onClick={cancel}
          />
        </div>
        <div className="popup-body">
          <div className="popup-body-pin">
            <div className="popup-popuppin-contenido-element">
              <div className="label popuppin-popup-label">Agente</div>
              <Dropdown
                id={AGENT_DROPDOWN_ID}
                size={0}
                tabIndex={1}
                optionList={agentList}
                op={selectedAgentId}
                onChange={(item) => setSelectedAgentId(item.id)}
              />
            </div>
            <div className="popup-popuppin-contenido-element">
              <div className="label popuppin-popup-label">PIN</div>
              <InputData
                id={PIN_INPUT_ID}
                tabIndex={2}
                maxLength={10}
                inactive={false}
                type="type-only-numbers"
                password={true}
                forceCenter={true}
                size={0}
                input={pin}
                onChange={onChangePin}
                onEnter={validatePin}
              />
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <div className="popup-row-buttons">
            <ButtonIconH
              text="Aceptar"
              disabled={validatingPin}
              onClick={validatePin}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};
